<template>
    <div :class="{'dark-theme': dark}" class="ns-paginate-pagination-container">
        <slot
            :currentPage="currentPage"
            :pageCount="contents.num_total_pages"
            name="pagination"
        >

            <el-pagination
                v-if="displayPaginator"
                :layout="`${windowWidth < 500 ? '': 'sizes, '}prev, pager, next`"
                :small="windowWidth < 500"
                :page-size="itemPerPage"
                :page-sizes="pagesSize"
                :page-count="contents.num_total_pages"
                :current-page="currentPage"
                :popper-class="dark ? 'ns-pagination-dark-theme' : ''"
                background
                @current-change="emitLoadSpecificPage"
                @size-change="emitOnSizeChange"
            >
            </el-pagination>
        </slot>
    </div>
</template>

<script>

export default {

    props: {
        contents: {
            type: Object,
            required: true,
        },
        windowWidth: {
            type: Number,
            required: true,
        },
        itemPerPage: {
            type: Number,
            required: true,
        },
        pagesSize: {
            type: Array,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        dark: {
            type: Boolean,
            required: true,
        },
        autoHidePaginatorIfOnePageOnly: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        displayPaginator(){
            if(!this.contents){
                return false;
            }
            if(this.contents.num_total_pages <= 1){
                // Display Paginator if autoHide is False
                return !this.autoHidePaginatorIfOnePageOnly;
            }
            return true;
        },
    },
    methods: {
        emitLoadSpecificPage(number) {
            this.$emit('loadSpecificPage', number);
        },
        emitOnSizeChange(val) {
            this.$emit('onSizeChange', val);
        }
    },
};
</script>

<style lang="scss">

.ns-paginate-pagination-container {
    float: right;
    margin-right: 30px;
    .el-pagination {
        padding: 0;
        .btn-next {
            margin-right: 0;
        }
        .btn-next, .btn-prev {
            background-color: transparent;
            &:hover {
                color: #96CAFF;
            }
            &:disabled {
                color: #C0C4CC;
            }
        }
        .el-pager {
            .active, .number {
                background-color: transparent !important;
            }
            .number:not(.active):hover {
                color: #96CAFF;
            }
            .active {
                color: #409EFF !important;
            }
        }
        .el-input {
            input {
                border: none;
                background-color: #ECF5FE;
            }
            input, i {
                color: #96CAFF;
            }
        }
    }
    &.dark-theme {
        .el-input {
            input {
                border: 1px solid #4E4E4E;
                background-color: transparent;
            }
            input, i {
                color: #EAEBEF;
            }
            &:hover, &:active, &:focus, &.is-focus {
                input {
                    border-color: #C0C4CC;
                }
            }
        }
        .btn-next, .btn-prev {
            background-color: transparent !important;
            color: #C0C4CC;
            &:hover {
                color: #96CAFF;
            }
            &:disabled {
                color: #606266 !important;
            }
        }
        .el-pager {
            .number, li {
                color: #EAEBEF;
                background-color: transparent !important;
            }
            .number:not(.active):hover {
                color: #96CAFF;
            }
            .active {
                color: #409EFF !important;
            }
        }
    }
}
.ns-pagination-dark-theme {
    background-color: #444444 !important;
    border-color: #444444 !important;
    .el-select-dropdown__item {
        color: #EEEEEE !important;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
        background-color: #222222 !important;
    }
    .popper__arrow {
        border-bottom-color: #444444 !important;
        &::after {
            border-bottom-color: #444444 !important;
        }
    }
}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/-new-ns-paginate-pagination.vue